module.exports = __webpack_public_path__ + "img/Asistencia-tecnologica-logo-training.1b9a4b8e.svg";